import React, {useState} from "react";
import {classNames} from "../../../common/util/util-helpers";
import {Loader} from "../../../common/components/loader";
import {CheckIcon, ChevronDownIcon, ChevronUpIcon} from "@heroicons/react/20/solid";

export default function PermissionsMenu({permissions = [], isLoading, onSelectCategory, filter = "", translate, selectedItems = [], onToggleSelectedItem}) {
    const [expandedItems, setExpandedItems] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("");

    function onExpandedItem(name) {
        if (expandedItems.includes(name)) {
            setExpandedItems(prevState => {
                const index = prevState.findIndex(it => it === name);
                prevState.splice(index, 1);
                return [...prevState]
            });
        } else {
            setExpandedItems(prevState => {
                prevState.push(name);
                return [...prevState];
            });
        }
    }

    function onExpandAllClick() {
        setExpandedItems(permissions.map(it => it.Name));
    }

    const menu = permissions.reduce((memo, it) => {
        memo.push(renderMenuItem(it, expandedItems, onExpandedItem, selectedCategory, setSelectedCategory, onSelectCategory, filter, selectedItems, onToggleSelectedItem))
        return memo;
    }, []);


    return <>
        <div className='flex gap-2'>
            <button
                className="btn btn-outline-secondary pl-2 pr-1 w-full justify-between" onClick={() => {
                onExpandAllClick();
            }}>
                Expand All <div className="flex flex-col">
                <ChevronUpIcon className="size-5 relative top-1.5"/>
                <ChevronDownIcon className="size-5 relative bottom-1.5"/>
            </div>
            </button>

            <button
                className="btn btn-outline-secondary pl-2 pr-1 w-full justify-between" onClick={() => {
                setExpandedItems([]);
            }}>

                Collapse All <div className="flex flex-col">
                <ChevronDownIcon className="size-5 relative top-1"/>
                <ChevronUpIcon className="size-5 relative bottom-1"/>
            </div>
            </button>
        </div>

        <div className="w-60 bg-popup rounded-card border border-tm-gray-200 overflow-y-auto">
            {isLoading && (
                <div className="p-4 flex justify-center">
                    <Loader disableContainer={true}/>
                </div>
            )}

            {menu}

            {!isLoading && !menu.find(it => !!it) && (
                <div className="p-6 text-center">{translate("text.no_results")}</div>
            )}
        </div>
    </>
}

const renderMenuItem = (it, expandedItems, setExpandedItems, selectedCategory, setSelectedCategory, onSelectItem, filter, selectedItems, onToggleSelectedItem) => {
    const isExpanded = expandedItems.includes(it.Name);
    const hasChildren = !!it?.ChildrenGroups?.length;

    const filteredChildrenGroups = [...it?.ChildrenGroups].reduce((memo, group) => {
        if (group.Name.toLowerCase().search(filter.toLowerCase()) > -1) {
            memo.push(group);
        }
        return memo;
    }, []);

    const hasFilterResults = !filter || !!filteredChildrenGroups.length;

    if (!hasFilterResults) {
        return null;
    }

    return (
        <React.Fragment>
            <button
                onClick={() => setExpandedItems(it.Name)}
                disabled={!hasChildren}
                className="hover:bg-tm-gray-50 text-tm-gray-700 group w-full flex items-center px-4 py-2 text-sm font-medium rounded-btn cursor-pointer"
            >
                <div>
                    {it.Name}
                </div>

                {hasChildren && (
                    <svg
                        className={
                            classNames(
                                "text-tm-gray-400 ml-auto shrink-0 h-5 w-5 transform transition-colors ease-in-out duration-150",
                                isExpanded ? "rotate-90" : undefined
                            )
                        }
                    >
                        <path d="M6 6L14 10L6 14V6Z" fill="currentColor"/>
                    </svg>
                )}
            </button>

            {isExpanded && hasChildren && (
                <ChildrenGroup
                    parentName={it.Name}
                    childrenGroups={filteredChildrenGroups}
                    selectedCategory={selectedCategory}
                    setSelectedCategory={setSelectedCategory}
                    onSelectItem={onSelectItem}
                    selectedItems={selectedItems}
                    onToggleSelectedItem={onToggleSelectedItem}
                />
            )}
        </React.Fragment>

    );
}

const ChildrenGroup = ({childrenGroups, selectedCategory, setSelectedCategory, parentName, onSelectItem, selectedItems, onToggleSelectedItem}) => {
    return <div>
        <button className="space-y-2 w-full px-2 mb-4">
            {childrenGroups.map(it => {
                const isShiftSelected = selectedItems.some(i => i.categoryName === parentName && i.subCategoryName === it.Name);
                return (
                    <button
                        key={it.Name}
                        onClick={(e) => {
                            if (e.shiftKey) {
                                onToggleSelectedItem(parentName, it);
                            } else {
                                onSelectItem(parentName, it);
                                setSelectedCategory(it.Name);
                            }
                        }}
                        className={
                            classNames(
                                it.Name === selectedCategory ? "bg-primary/10 text-tm-gray-900" : "text-tm-gray-700",
                                isShiftSelected ? "border-primary bg-primary/10 !text-primary" : "border-transparent",
                                "border relative cursor-pointer font-semibold text-left hover:bg-tm-gray-50 group w-full flex grow items-center pl-11 pr-2 py-1.5 text-sm rounded-btn hover:text-tm-gray-900 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-primary"
                            )
                        }
                    >

                        {isShiftSelected && <CheckIcon className="w-3.5 h-3.5 text-primary absolute left-2 top-2.5" />}

                        {it.Name}
                    </button>
                )
            })}
        </button>
    </div>
}
